import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          Research Team
        </h1>

        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={3} className="project-card">
            <ProjectCard
              imgPath="https://media.licdn.com/dms/image/C4D03AQFEVzJE9RKCQw/profile-displayphoto-shrink_800_800/0/1602237788823?e=2147483647&v=beta&t=gohPkz2UwpA6-PWXxNNtoM1WWjbfRZkG-GMMqhoJ9gc"
              isBlog={false}
              title="Stefano Ferilli"
              description="Associate Professor at the department of Computer Science, University of Bari Aldo Moro."
              ghLink="/stefano_ferilli"
              demoLink=""
            />
          </Col>

          <Col md={3} className="project-card">
            <ProjectCard
              imgPath="https://www.uniba.it/logo.png"
              isBlog={false}
              title="Domenico Re David"
              description="RTDB Researcher at the department of Economics, University of Bari Aldo Moro."
              ghLink=""
              demoLink=""
            />
          </Col>

          <Col md={3} className="project-card">
            <ProjectCard
              imgPath="https://i1.rgstatic.net/ii/profile.image/1159596324454400-1653480716296_Q512/Davide-Di-Pierro.jpg"
              isBlog={false}
              title="Davide Di Pierro"
              description="Ph.D student at the department of Computer Science, University of Bari Aldo Moro."
              ghLink=""
              demoLink=""
            />
          </Col>

          <Col md={3} className="project-card">
            <ProjectCard
              imgPath="https://phd.uniroma1.it/dottorati/cartellaProfili/e732d544-07a2-480e-b5a6-ec87f1c35950.jpg"
              isBlog={false}
              title="Eleonora Bernasconi"
              description="RTDA Researcher at the department of Computer Science, University of Bari Aldo Moro."
              ghLink=""
              demoLink=""
            />
          </Col>

          <Col md={3} className="project-card">
            <ProjectCard
              imgPath="https://media.licdn.com/dms/image/D4D03AQEkhE4NMyumzQ/profile-displayphoto-shrink_800_800/0/1705578651628?e=2147483647&v=beta&t=LOTATfCR3ve-L2dS2r-enwo3e1J6ha6mRdCWfsmV8YQ"
              isBlog={false}
              title="Giorgio Di Nunzio"
              description="Associate Professor at the Department of Information Engineering University of Padova, Italy."
              ghLink="/giorgio_maria_di_nunzio"
              demoLink=""
            />
            {/* Dipartimento di Ingegneria dell'Informazione  */}
          </Col>
          {/* Laura Menotti (PhD) Dipartimento di Ingegneria dell’Informazione */}
          <Col md={3} className="project-card">
            <ProjectCard
              imgPath="https://media.licdn.com/dms/image/C4E03AQFCJOYYIZaWnQ/profile-displayphoto-shrink_800_800/0/1636132039162?e=2147483647&v=beta&t=XAGljw492fqihPeLkd5VwShABVvFN0rnbYf1_G0jCyM"
              isBlog={false}
              title="Laura Menotti"
              description="Ph.D student at the Department of Information Engineering University of Padova, Italy."
              ghLink=""
              demoLink=""
            />
          </Col>

          {/* Federica Vezzani (RTDB) del Dipartimento di Studi Linguistici e Letterari */}
          <Col md={3} className="project-card">
            <ProjectCard
              imgPath="https://media.licdn.com/dms/image/D4D03AQH1bIMmCPnbhw/profile-displayphoto-shrink_800_800/0/1682026514930?e=2147483647&v=beta&t=iI1wGJyLaL4DQ4A1gVM60zzaTUL-9gOQQxYPeUbpenA"
              isBlog={false}
              title="Federica Vezzani"
              description="RTDB Researcher at the Department of Linguistic and Literary Studies, University of Padova, Italy."
              ghLink=""
              demoLink=""
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
